export default __webpack_public_path__ + "static/media/withoutPendingTasks.2b583202.svg";